import PropTypes from 'prop-types'

const ToolbarIcon = () => (
  <svg viewBox="0 1.5 51 49" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g className="nc-icon-wrapper">
      <path d="M42,3H6A3,3,0,0,0,3,6V42a3,3,0,0,0,3,3H42a3,3,0,0,0,3-3V6A3,3,0,0,0,42,3Z" fill="#e6e6e6" />
      <rect x="9" y="28" width="13" height="11" rx="1" fill="#867fe8" />
      <rect x="9" y="9" width="13" height="15" rx="1" fill="#867fe8" />
      <rect x="26" y="9" width="13" height="30" rx="1" fill="#47b0ea" />
    </g>
  </svg>
)

ToolbarIcon.displayName = 'ToolbarIcon'

ToolbarIcon.propTypes = {
  title: PropTypes.string
}

ToolbarIcon.defaultProps = {
  title: 'Toolbar'
}
export default ToolbarIcon
